import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tab, Header } from "semantic-ui-react";
import TicketList from "./TicketList";
import { useParams } from "react-router-dom";
import { BaseUrl } from "../formcomponents/Constants";
const TicketDataListwithCat = () => {
  const [rowData, setrowData] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // Initialize with the desired default tab index (e.g., 0 for visaCategoryId: 0)
  const { catId } = useParams();
  const color = "blue";

  useEffect(() => {
    getWorkCatList();
  }, [catId]); // Add 'id' to the dependency array to re-fetch data when 'id' changes

  const getWorkCatList = () => {
    axios
      .post(BaseUrl + "listSSVisaCategory", {
        workCategory: "",
        visaTypeNumber: 35,
      })
      .then((res) => {
        console.log("catogery id", res.data);

        const tempArr = [];

        for (let i = 0; i < res.data.length; i++) {
          tempArr.push({
            visaCategoryId: res.data[i].visaCategoryId,
            visaCategory: res.data[i].visaCategory,
          });
        }
        tempArr.push({
          visaCategoryId: 0,
          visaCategory: "All",
        });
        setrowData(tempArr);

        // Find the index of the visaCategoryId from useParams() and set it as the active tab index
        if (catId != "null") {
          const indexToSetActive = tempArr.findIndex(
            (item) => item.visaCategoryId === Number(catId)
          );
          setActiveTabIndex(indexToSetActive);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleTabChange = (e, { activeIndex }) => {
    console.log("cat id", activeIndex);
    setActiveTabIndex(activeIndex); // Update the active tab index when a tab is clicked
  };

  const panes = rowData.map((item, index) => ({
    menuItem: `${item.visaCategory}`,
    render: () => (
      <Tab.Pane attached={false} key={index}>
        <TicketList visaCategoryId={item.visaCategoryId} />
      </Tab.Pane>
    ),
  }));

  return (
    <div>
      <Header dividing size="huge" as="h1">
       Ticket Data List
      </Header>
      <Tab
        menu={{ color, attached: false, tabular: false, className: "wrapped" }}
        panes={panes}
        activeIndex={activeTabIndex} // Set the active tab index
        onTabChange={handleTabChange} // Handle tab change events
      />
    </div>
  );
};



export default TicketDataListwithCat;
